import styled from 'styled-components';
import DownloadIcon from '../../assets/images/download-icon.svg';

const DownloadDataIcon = styled.span`
  background: url(\"${DownloadIcon}\") no-repeat left center;
  background-size: 17px 17px;
  display: block;
  position: relative;
  height: 27px;
  width: 17px;
`;

export default DownloadDataIcon;
